// src/pages/NotFound.js
import React from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Box,
  Paper
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import ErrorIcon from '@material-ui/icons/Error';
import HomeIcon from '@material-ui/icons/Home';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 500,
    width: '100%',
  },
  icon: {
    fontSize: 80,
    color: theme.palette.error.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.error.main,
  },
  button: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1),
  },
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <ErrorIcon className={classes.icon} />
        <Typography variant="h3" className={classes.title} gutterBottom>
          404
        </Typography>
        <Typography variant="h5" gutterBottom>
          Page non trouvée
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </Typography>
        <Box>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/dashboard"
            startIcon={<HomeIcon />}
            className={classes.button}
          >
            Retour au tableau de bord
          </Button>
          {/* <Button
            variant="outlined"
            color="primary"
            component={Link}
            to="/login"
            className={classes.button}
          >
            Page de connexion
          </Button> */}
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFound;